import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const BlockStyleSeven = () => {
    return (
        <Fragment>
            <div className="block-style-seven pl-90 mb-45 pl-md-0">
                <h6 className="sub-title-two mb-20">사이버 보안</h6>
                <h2 className="sect-title mb-20">기업 디지털 자산을 보호하는 보안 중심 IT 아키텍처</h2>
                <p>웹 보안, 인프라 보안, 취약점 분석, 접근 제어, 데이터 보호까지 안정적인 비즈니스 운영 환경을 구축합니다. 개발 단계부터 보안을 설계에 반영합니다.</p>
                <div className="icon-box">
                    <span><img src="assets/img/icon/icon-28c.svg" alt="웹 보안 아이콘"/></span>
                    <span><img src="assets/img/icon/icon-29c.svg" alt="클라우드 보안 아이콘"/></span>
                    <span><img src="assets/img/icon/icon-30c.svg" alt="데이터 보호 아이콘"/></span>
                    <span><img src="assets/img/icon/icon-31c.svg" alt="접근 제어 아이콘"/></span>
                    <span><img src="assets/img/icon/icon-32c.svg" alt="보안 운영 아이콘"/></span>
                </div>
                <Link className="theme_btn mt-55" to="/contact">보안 상담 신청하기</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleSeven
